export enum CodetableId {
  unit = 31,
  location = 34,
  userGroup = 19
}
